"use client";
import React, { useState, useMemo } from "react";
import { Button } from "@/components";
import { getImageURL } from "@/lib";
import { cleanSEOTags } from "@/utilities";

export const ProductPageVariationSection = ({ data = {}, slug = "" }) => {
    const {
        heading,
        description,
        variation_list = [],
        image,
        warranty,
        additional_details,
        range_heading,
        warranty_heading,
        detail_heading,
        additional_details_heading,
    } = data;

    const variationOptions = useMemo(
        () =>
            variation_list.map((variation, idx) => ({
                label: variation?.variation_name,
                value: idx,
            })),
        [variation_list]
    );

    const [selectedIdx, setSelectedIdx] = useState(0);

    if (
        !heading &&
        !description &&
        !additional_details &&
        !warranty &&
        !range_heading &&
        !warranty_heading &&
        !detail_heading &&
        !additional_details_heading &&
        (!variation_list || variation_list.length === 0) &&
        (!image || !image.src)
    ) {
        return null;
    }

    const selectedVariation =
        variation_list[selectedIdx] || variation_list[0] || {};
    const selectedDetail =
        (selectedVariation?.variation_detail &&
            selectedVariation?.variation_detail[0]) ||
        {};

    return (
        <section className="product_comparison">
            <div className="custom-container">
                <div className="row">
                    <div className="col-md-12 col-lg-4 col-xl-4">
                        {(heading || description) && (
                            <div className="section_header">
                                {heading && (
                                    <h4
                                        className="heading fs-48 fw-300"
                                        dangerouslySetInnerHTML={{
                                            __html: cleanSEOTags(heading),
                                        }}
                                    />
                                )}
                                {description && (
                                    <div className="content__wrap">
                                        <p
                                            dangerouslySetInnerHTML={{
                                                __html: cleanSEOTags(description),
                                            }}
                                        />
                                    </div>
                                )}
                            </div>
                        )}
                        {image?.src && (
                            <div className="product_comparison_left_img">
                                <img
                                    loading="lazy"
                                    src={getImageURL(image?.src)}
                                    alt={image?.alt || ""}
                                />
                            </div>
                        )}
                    </div>
                    <div className="col-xl-2" />
                    <div className="col-md-12 col-lg-8 col-xl-6">
                        {variation_list && variation_list.length > 0 && (
                            <div className="product_comparison_table_main">
                                <div className="table-responsive">
                                    <table>
                                        <thead>
                                            <tr>
                                                <th />
                                                <th>
                                                    <div className="select_part_comparison">
                                                        <select
                                                            className="form-field"
                                                            name="variation"
                                                            value={selectedIdx}
                                                            onChange={(e) =>
                                                                setSelectedIdx(
                                                                    Number(
                                                                        e.target
                                                                            .value
                                                                    )
                                                                )
                                                            }
                                                        >
                                                            {variationOptions.map(
                                                                (opt) => (
                                                                    <option
                                                                        key={
                                                                            opt.value
                                                                        }
                                                                        value={
                                                                            opt.value
                                                                        }
                                                                    >
                                                                        {
                                                                            opt.label
                                                                        }
                                                                    </option>
                                                                )
                                                            )}
                                                        </select>
                                                    </div>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {(selectedDetail?.variation_image
                                                ?.src ||
                                                selectedVariation?.variation_name) && (
                                                <tr>
                                                    <td></td>
                                                    <td>
                                                        <div className="compare_img">
                                                            {selectedDetail
                                                                ?.variation_image
                                                                ?.src && (
                                                                <img
                                                                    loading="lazy"
                                                                    src={getImageURL(
                                                                        selectedDetail
                                                                            .variation_image
                                                                            .src
                                                                    )}
                                                                    alt={
                                                                        selectedDetail
                                                                            ?.variation_image
                                                                            ?.alt ||
                                                                        selectedVariation?.variation_name ||
                                                                        ""
                                                                    }
                                                                />
                                                            )}
                                                        </div>
                                                    </td>
                                                </tr>
                                            )}
                                            {selectedDetail?.power_range && (
                                                <tr>
                                                    <td>
                                                        <span
                                                            dangerouslySetInnerHTML={{
                                                                __html: cleanSEOTags(selectedDetail?.range_heading),
                                                            }}
                                                        />
                                                    </td>
                                                    <td
                                                        dangerouslySetInnerHTML={{
                                                            __html: cleanSEOTags(selectedDetail?.power_range),
                                                        }}
                                                    />
                                                </tr>
                                            )}
                                            {selectedDetail?.warranty && (
                                                <tr>
                                                    <td>
                                                        <span
                                                            dangerouslySetInnerHTML={{
                                                                __html: cleanSEOTags(selectedDetail?.warranty_heading),
                                                            }}
                                                        />
                                                    </td>
                                                    <td
                                                        dangerouslySetInnerHTML={{
                                                            __html: cleanSEOTags(selectedDetail?.warranty),
                                                        }}
                                                    />
                                                </tr>
                                            )}
                                            {selectedDetail?.detail && (
                                                <tr>
                                                    <td>
                                                        <span
                                                            dangerouslySetInnerHTML={{
                                                                __html: cleanSEOTags(selectedDetail?.detail_heading),
                                                            }}
                                                        />
                                                    </td>
                                                    <td
                                                        dangerouslySetInnerHTML={{
                                                            __html: cleanSEOTags(selectedDetail?.detail),
                                                        }}
                                                    />
                                                </tr>
                                            )}
                                            {selectedDetail?.additional_details && (
                                                <tr>
                                                    <td>
                                                        <span
                                                            dangerouslySetInnerHTML={{
                                                                __html: cleanSEOTags(selectedDetail?.additional_details_heading),
                                                            }}
                                                        />
                                                    </td>
                                                    <td
                                                        dangerouslySetInnerHTML={{
                                                            __html: cleanSEOTags(selectedDetail?.additional_details),
                                                        }}
                                                    />
                                                </tr>
                                            )}

                                            {(selectedDetail?.variation_image
                                                ?.src ||
                                                selectedDetail?.power_range ||
                                                selectedDetail?.detail) && (
                                                <tr>
                                                    <td />
                                                    <td></td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                    {(selectedDetail.data_sheet?.src ||
                                        selectedDetail.shop_now?.url) && (
                                        <div className="btn-group d-flex justify-content-center">
                                            {selectedDetail.data_sheet?.src && (
                                                <a
                                                    href={getImageURL(
                                                        selectedDetail
                                                            ?.data_sheet?.src
                                                    )}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    <Button
                                                        role="button"
                                                        label="Data sheet"
                                                    />
                                                </a>
                                            )}
                                            {selectedDetail?.shop_now?.url && (
                                                <a
                                                    href={
                                                        selectedDetail?.shop_now
                                                            ?.url
                                                    }
                                                    target={
                                                        selectedDetail?.shop_now
                                                            ?.open_new_tab ===
                                                        "yes"
                                                            ? "_blank"
                                                            : "_self"
                                                    }
                                                    rel={
                                                        selectedDetail?.shop_now
                                                            ?.open_new_tab ===
                                                        "yes"
                                                            ? "noopener noreferrer"
                                                            : undefined
                                                    }
                                                >
                                                    <Button
                                                        role="button"
                                                        label={
                                                            selectedDetail
                                                                ?.shop_now
                                                                ?.title ||
                                                            "Shop Now"
                                                        }
                                                    />
                                                </a>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};
